import PropTypes from "prop-types";
import { Container, } from 'reactstrap';
// import { personaPageData } from '../../common';
import * as Icons from "../../common/icons/personaPageDataIcons";

// import Loadable from "../../components/Loadable"

// const Header = Loadable(
//     lazy(() => import('../../components/header/header'))
// )


const ChallengesSection = ({ challenges }) => {
    const SolidArrowIcon = Icons['SolidArrowIcon'];

    return (
        <section className="position-relative challenges-section">
            <Container className=" py-5 Demographics-container py-5">
                <div className="Demographics py-5">
                    <div className="pt-5 Identifiers-div">
                        <div className="pt-5 position-relative d-flex align-items-center justify-content-start gap-2">
                            <div className="position-absolute left-m-20">
                                <div className="number-icon position-relative">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="148" height="142" viewBox="0 0 148 142" fill="none">
                                        <g clipPath="url(#clip0_2081_524)">
                                            <path d="M94.6628 13.7787L85.5464 28.6539C97.0144 33.2084 106.159 43.0811 109.259 55.9917C114.319 77.0755 101.332 98.2698 80.2478 103.33C67.34 106.428 54.389 102.76 45.1244 94.6087L36.0079 109.484C49.1431 119.861 66.7364 124.328 84.2769 120.118C114.634 112.83 133.336 82.3158 126.049 51.9585C121.839 34.4207 109.873 20.7699 94.6628 13.7787Z" fill="#FFB703" />
                                            <path d="M86.0522 8.49955L76.9358 23.3748C88.4039 27.9292 97.5486 37.802 100.649 50.7125C105.709 71.7964 92.7211 92.9907 71.6372 98.0504C58.7294 101.149 45.7771 97.4786 36.5138 89.3295L27.3973 104.205C40.5325 114.582 58.1258 119.049 75.6663 114.838C106.024 107.551 124.726 77.0366 117.438 46.6793C113.229 29.1416 101.262 15.4907 86.0522 8.49955Z" stroke="#1A1E28" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_2081_524">
                                                <rect width="113.733" height="101.012" fill="white" transform="translate(0 51.1636) rotate(-26.7344)" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <span className="number position-absolute">3</span>
                                </div>
                            </div>
                            <h1 className="title-Identifiers w-100 my-3">{challenges?.title}</h1>
                        </div>
                        <div className="d-flex align-items-start justify-content-start gap-4">
                            <div className="px-3 identifiers-list">
                                <ul className="identifiers-ul w-75">
                                    {challenges?.listData?.length > 0 && challenges?.listData?.map((challenge) => {
                                        return (
                                            <li key={`challenge_${challenge?.id}`} className="identifiers-li d-flex align-items-center gap-3 justify-content-start">
                                                <div className="identifiers-hover">
                                                    {SolidArrowIcon && <SolidArrowIcon />}
                                                    <img rel="preload" src={'/assets/images/second.svg'} alt="vector-img" />
                                                </div>
                                                <span>{challenge?.text}</span>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                            <div className="position-relative d-flex align-items-center justify-content-center w-100">
                                <div className="quibImage-img w-100 d-flex align-items-center justify-content-end">
                                    <img rel="preload" src={'/assets/images/challenges.svg'} alt="vector-img" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        </section>
    );
}

ChallengesSection.propTypes = {
    classes: PropTypes.object
};

export default ChallengesSection;
